import { render, staticRenderFns } from "./FooterBack.vue?vue&type=template&id=33fef042&"
import script from "./FooterBack.vue?vue&type=script&lang=js&"
export * from "./FooterBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports